import React from 'react';
import styles from './ProfilePageEditPopup.module.css';
import checkImg from '../../../../assets/img/tick.svg';
import closeImg from '../../../../assets/img/delete.svg';

export default function EditFieldPopup({
  title,
  fieldName,
  profileData,
  onSubmit,
  onClose,
  submitLoading,
  refetchProfile
}) {
  const [value, setValue] = React.useState(profileData[fieldName] || '');
  const [error, setError] = React.useState(null);

  React.useEffect(
    () => {
      setValue(profileData[fieldName] || '');
      setError(null);
    },
    [fieldName, profileData]
  );

  const handleSubmit = async () => {
    setError(null);

    try {
      if (fieldName === 'firstname' || fieldName === 'lastname') {
        if (!/^[a-zA-Z\s'`-]+$/.test(value.trim())) {
          setError('Name cannot include numbers or special characters');
          return;
        }
      } else if (fieldName === 'telephone') {
        if (!/^\+?[\d\s\-()]+$/.test(value.trim())) {
          setError('Phone number can only contain digits');
          return;
        }
      }
      const input = {
        firstname: fieldName === 'firstname' ? value : profileData.firstname,
        lastname: fieldName === 'lastname' ? value : profileData.lastname,
        telephone: fieldName === 'telephone' ? value : profileData.telephone,
        company: fieldName === 'company' ? value : profileData.company
      };
      const res = await onSubmit(input);

      if (res.data.updateProfileData) {
        await refetchProfile();
        onClose();
      } else {
        setError('Update failed');
      }
    } catch (err) {
      setError('Something went wrong', { err });
    }
  };
  function renderFieldLabel() {
    switch (fieldName) {
      case 'firstname':
        return (
          <div className={styles.subtitle}>
            First name<span className={styles.star}>*</span>
          </div>
        );
      case 'lastname':
        return (
          <div className={styles.subtitle}>
            Last name<span className={styles.star}>*</span>
          </div>
        );
      case 'company':
        return (
          <div className={styles.subtitle}>
            Company<span className={styles.star}>*</span>
          </div>
        );
      case 'telephone':
        return (
          <div className={styles.subtitle}>
            Telephone<span className={styles.star}>*</span>
          </div>
        );
      default:
        return (
          <div className={styles.subtitle}>
            Error while trying to get the name
          </div>
        );
    }
  }

  return (
    <div className={styles.modalOverlay} role="presentation" onClick={onClose}>
      <div
        className={styles.modalContainer}
        role="presentation"
        onClick={e => e.stopPropagation()}
      >
        <div className={styles.modalTitle}>{title}</div>
        <div className={styles.topDivider} />

        <div className={styles.modalContent}>
          {renderFieldLabel()}
          <input
            className={styles.input}
            type="text"
            name={fieldName}
            value={value}
            onChange={e => setValue(e.target.value)}
          />
          {error && <div className={styles.error}>{error}</div>}
        </div>
        <div className={styles.bottomDivider} />
        <div className={styles.modalFooter}>
          <button
            type="button"
            className={styles.confirmButton}
            onClick={handleSubmit}
            disabled={submitLoading}
          >
            <img src={checkImg} alt="save" />
          </button>
          <button
            className={styles.closeButton}
            type="button"
            onClick={onClose}
          >
            <img src={closeImg} alt="close" />
          </button>
        </div>
      </div>
    </div>
  );
}
